// extracted by mini-css-extract-plugin
module.exports = {"pintura":"pintura_pintura__2qP3s","image_editor_spin":"pintura_image_editor_spin__N1xxe","pintura-img-loading":"pintura_pintura-img-loading__A4GVr"};